import React, { SVGProps } from 'react'
export const VipNewYearCrownSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={144}
    height={124}
    viewBox="0 0 144 124"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M75.3125 14.3611C73.4474 11.7384 69.5527 11.7384 67.6877 14.3611L38.8888 54.8587C37.3219 57.0622 34.2187 57.4823 32.1222 55.7748L11.4356 38.9263C8.11341 36.2205 3.20391 39.0334 3.85814 43.2678L13.7015 106.977C14.4063 111.539 18.3323 114.905 22.9479 114.905H70.2625H72.9064H120.052C124.668 114.905 128.594 111.539 129.299 106.977L139.142 43.2678C139.796 39.0335 134.887 36.2205 131.564 38.9263L110.878 55.7748C108.781 57.4823 105.678 57.0621 104.111 54.8587L75.3125 14.3611Z"
      fill="url(#paint0_linear_2449_24934)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M66.9698 80.4273C66.9698 80.4273 67.8732 85.844 70.6895 89.6159C70.6895 89.6159 71.8692 91.2825 70.3919 92.686C68.9041 94.0786 66.0133 97.686 65.1419 99.1443C64.2704 100.614 65.7689 101.107 66.8954 100.975C68.022 100.844 71.3697 100.34 73.1445 99.9667C74.8343 99.55 75.6314 99.9338 76.3647 101.392C77.1086 102.85 78.4265 104.923 80.3714 107.291C82.3162 109.66 83.2515 107.335 83.2727 105.131C83.294 102.927 83.3577 99.1882 83.3577 99.1882C83.3577 99.1882 83.3896 97.2145 86.5992 96.743C89.8087 96.2825 92.5294 95.2518 92.5294 95.2518C92.5294 95.2518 94.3893 94.9229 94.655 93.6071C94.9207 92.2913 90.6058 90.8988 88.5334 90.0216C86.4185 89.2321 85.8446 88.8483 86.1209 86.5457C86.3972 84.2431 86.5885 80.2409 86.5885 80.2409C86.5885 80.2409 86.8968 78.8374 85.8021 78.651C84.7075 78.4646 79.84 83.333 79.84 83.333C79.84 83.333 78.926 84.6707 76.4816 83.3988C74.0479 82.1269 69.9562 79.5173 69.2442 78.958C68.5215 78.3988 66.5022 77.8835 66.9698 80.4273Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.9109 85.923C16.9109 85.923 21.0148 85.9082 24.1357 84.2845C24.1357 84.2845 25.5069 83.6148 26.3644 84.8732C27.2126 86.1382 29.5258 88.7042 30.4966 89.5224C31.4755 90.3419 32.0197 89.296 32.0581 88.4492C32.0966 87.6025 32.1272 85.0725 32.0656 83.7186C31.9616 82.4221 32.3405 81.8803 33.5043 81.5148C34.6695 81.1415 36.3565 80.4187 38.3373 79.269C40.3182 78.1194 38.7161 77.15 37.093 76.8692C35.47 76.5885 32.7198 76.0918 32.7198 76.0918C32.7198 76.0918 31.2678 75.8309 31.3061 73.4068C31.3524 70.9841 30.9194 68.8534 30.9194 68.8534C30.9194 68.8534 30.9004 67.442 29.9619 67.0878C29.0233 66.7335 27.4773 69.7487 26.581 71.1717C25.7443 72.6367 25.3922 73.0139 23.7271 72.5331C22.0619 72.0524 19.1329 71.43 19.1329 71.43C19.1329 71.43 18.1348 71.0338 17.8657 71.8188C17.5965 72.6038 20.602 76.7795 20.602 76.7795C20.602 76.7795 21.4788 77.6146 20.2466 79.2646C19.0158 80.9067 16.5988 83.6108 16.1007 84.0688C15.6013 84.5346 14.9783 85.962 16.9109 85.923Z"
      fill="white"
    />
    <path
      d="M119.804 79.4448C119.804 79.4448 113.193 85.9436 111.214 88.317L120.694 88.7126L126.83 98.3571L130.451 88.0345C130.451 88.0345 130.158 88.091 132.157 88.0345C132.157 88.0345 133.057 83.4643 133.057 81.8095C133.057 81.8095 134.381 74.5284 134.712 71.8809L127.384 74.5284L117.409 68.5759C117.449 68.331 119.17 78.2392 119.804 79.4448Z"
      fill="url(#paint1_linear_2449_24934)"
    />
    <path
      d="M80.5358 55.9632C80.5358 55.9632 76.1289 60.2957 74.8095 61.878L81.1295 62.1418L85.2197 68.5714L87.6342 61.6897C87.6342 61.6897 93.334 61.4887 94.6667 61.4511C94.6667 61.4511 91.289 57.6586 90.4182 56.9051C90.4182 56.9051 91.7376 51.1033 91.764 49.9731L85.5891 52.6856L78.9393 48.7173C78.9657 48.554 80.1135 55.1595 80.5358 55.9632Z"
      fill="white"
    />
    <path
      d="M53.0221 66.5697C53.0221 66.5697 49.1185 61.6625 54.4453 59.2993C59.7585 56.9361 61.8865 61.4818 61.5341 64.5679C61.1817 67.654 57.2781 68.5715 57.2781 68.5715C57.2781 68.5715 54.7842 68.3907 53.0221 66.5697Z"
      fill="white"
    />
    <path
      d="M69.11 30.8322C69.11 30.8322 66.5076 27.5608 70.0588 25.9853C73.6009 24.4098 75.0196 27.4403 74.7847 29.4977C74.5497 31.5551 71.9473 32.1667 71.9473 32.1667C71.9473 32.1667 70.2847 32.0462 69.11 30.8322Z"
      fill="white"
    />
    <path
      d="M9.53856 50.6893C9.53856 50.6893 6.93617 47.4179 10.4873 45.8424C14.0295 44.2669 15.4481 47.2974 15.2132 49.3548C14.9783 51.4122 12.3759 52.0238 12.3759 52.0238C12.3759 52.0238 10.7132 51.9034 9.53856 50.6893Z"
      fill="white"
    />
    <path
      d="M128.681 50.6893C128.681 50.6893 126.079 47.4179 129.63 45.8424C133.172 44.2669 134.591 47.2974 134.356 49.3548C134.121 51.4122 131.519 52.0238 131.519 52.0238C131.519 52.0238 129.856 51.9034 128.681 50.6893Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2449_24934"
        x1="3.61423"
        y1="10.5653"
        x2="3.61423"
        y2="114.01"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFDE6E" />
        <stop offset="1" stopColor="#FFD062" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2449_24934"
        x1="122.798"
        y1="78.5"
        x2="144.31"
        y2="80.1547"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
)
